export enum AppEndpoint {
  BLOB = '/v1/blobs/{blobHash}',
  FILTERS = '/v1/filters',
}

export enum AuthEndpoint {
  OTP_EMAIL_USERNAME = '/v1/auth/otp',
  OTP_VALIDATE = '/v1/auth/otp/callback',
  OTP_REGISTER = '/v1/auth/register',
  PERSONAL_DETAILS = '/v1/auth/personal_details',
  RATINGS = '/v1/auth/ratings',
  GOOGLE = '/v1/auth/google',
  APPLE = '/v1/auth/apple',
  LICHESS = '/v1/auth/lichess?redirectUrl=',
  LICHESS_RATINGS = '/v1/auth/lichess/ratings?redirectUrl=',
  JWT_REFRESH = '/v1/auth/refresh',
  TOKEN = '/v1/auth/token',
  HANDOFF = '/v1/auth/handoff',
  AUTH = '/v1/auth',
}

export enum ClubEndpoints {
  GET_CLUBS = '/v1/clubs',
  GET_CLUB_DETAILS = '/v1/clubs/{id}',
  GET_CLUB_DETAILS_BY_USERNAME = '/v1/clubs/username/{id}',
  GET_CLUBS_SEARCH = '/v1/clubs/search',
  CLUB_FOLLOW = '/v1/clubs/{id}/follow',
  CLUB_LOCATIONS = '/v1/clubs/{id}/locations',
  CLUB_LOCATION = '/v1/clubs/{id}/locations/{locationId}',
  CLUB_LOCATION_MAIN = '/v1/clubs/{id}/locations/headquarters',
  CLUB_ORGANIZERS = '/v1/clubs/{id}/organizers',
  CLUB_ORGANIZER = '/v1/clubs/{id}/organizers/{username}',
  CLUB_OWNER = '/v1/clubs/{id}/owner',
}

export enum SparksEndpoint {
  SPARKS = '/v1/sparks',
  SPARK_EXTEND_AVAILABILITIES = '/v1/sparks/extend_availabilities',
  SPARK_INTENTS = '/v1/sparks/intents',
  SPARK_INTENT = '/v1/sparks/intents/{id}',
  SPARK_INTENT_DATE = '/v1/sparks/intents/date/{date}',
  SPARK_INTENT_DATE_AVAILABILITY = '/v1/sparks/intents/date/{date}/availability',
  SPARK_INTENT_AVAILABILITY_HORIZON = '/v1/sparks/intents/availability-horizon',
  SPARK_INTENT_AVAILABILITY_HORIZON_INIT = '/v1/sparks/intents/availability-horizon/init',
  SPARK_INTENT_RESULTS = '/v1/sparks/intents/{id}/results',
  SPARK_INTENT_RESULTS_PRIORITIZED = '/v1/sparks/intents/{id}/results/prioritized',
  SPARK_INTENT_FIRESTORE = '/v1/sparks/intents/{id}/firestore',
  SPARK_WEEK_PREVIEW = '/v1/sparks/week-preview',
  SPARK_AVAILABILITIES = '/v1/sparks/availabilities',
  SPARK_PROPOSALS = '/v1/sparks/proposals',
  SPARK_PROPOSAL = '/v1/sparks/proposals/{id}',
  SPARK_PROPOSAL_INVITATIONS = '/v1/sparks/proposals/{id}/invitations',
  SPARK_PROPOSAL_ACCEPT_INVITATION = '/v1/sparks/proposals/{id}/acceptInvitation',
  SPARK_PROPOSAL_DECLINE_INVITATION = '/v1/sparks/proposals/{id}/declineInvitation',
  SPARK_PROPOSAL_WITHDRAW_INVITATION = '/v1/sparks/proposals/{id}/withdrawInvitation',
  SPARK_PROPOSAL_MARK_SUCCESS_AS_READ = '/v1/sparks/proposals/{id}/markSuccessAsRead',
  SPARK_PROPOSAL_CONFIRMATION = '/v1/sparks/proposals/{id}/confirmation',
  SPARK_PROPOSAL_MEET_ANYWAYS = '/v1/sparks/proposals/{id}/meet-anyways',
  SPARK_PROPOSAL_FIRESTORE = '/v1/sparks/proposals/{id}/firestore',
  SPARK_CONFIRMATIONS = '/v1/sparks/confirmations',
  SPARK_CONFIRMATION = '/v1/sparks/confirmations/{id}',
  SPARK_MATCHES = '/v1/sparks/matches',
  SPARK_INVITATIONS_RESPOND = '/v1/sparks/invitations/respond',
}

export enum LocationEndpoint {
  GET_LOCATIONS = '/v1/locations',
  GET_LOCATIONS_MAP = '/v1/locations/markers',
  GET_LOCATIONS_SPARKABLE = '/v1/locations/sparkable',
  AUTOCOMPLETE_LOCATIONS = '/v1/locations/complete',
  // CITY = '/v1/locations/city',
  CITY_FOR = '/v1/locations/places/city',
  GOOGLE_PLACE_DETAILS = '/v1/locations/places/details/{id}',
  GOOGLE_REVERSE_GEOCODE = '/v1/locations/reverse',
  LOCATION_FAVORITES = '/v1/locations/{id}/favorites',
  GET_LOCATION_DETAILS = '/v1/locations/{id}',
  LOCATION_COVER = '/v1/locations/{id}/cover',
  LOCATION_IMAGES = '/v1/locations/{id}/images',
  LOCATION_IMAGES_LIKE = '/v1/locations/images/{id}/like',
  LOCATION_IMAGE = '/v1/locations/images/{id}',
  LOCATION_COMMENTS = '/v1/locations/{id}/comments',
  LOCATION_COMMENT_DELETE = '/v1/locations/comments/{id}',
  LOCATION_PIN_COVER = '/v1/locations/{id}/pin-cover',
  LOCATION_FIRESTORE = '/v1/locations/{id}/firestore',
  CHECK_IN = '/v1/locations/{id}/check_in',
}

export enum FirebaseEndpoint {
  AUTH = '/v1/firebase/auth',
  GAMBIT_FIRESTORE = '/v1/firebase/gambit/{id}',
  CHAT_FIRESTORE = '/v1/firebase/chat/{id}',
}

export enum GambitEndpoint {
  GAMBITS = '/v1/gambits',
  GAMBIT_DETAILS = '/v1/gambits/{id}',
  GAMBIT_FIRESTORE = '/v1/gambits/{id}/firestore',
  GAMBIT_INVITATION = '/v1/gambits/{id}/updateInvitation',
  GAMBIT_RESPOND = '/v1/gambits/respond',
  GAMBIT_LIVE = '/v1/gambits/live',
  GAMBIT_DISMISS_RECENT = '/v1/gambits/{id}/attendance/dismiss-recent',
  GAMBIT_USER_GATHERING_INVITATIONS = '/v1/gambits/user/{userId}/gathering-invitations',
}

export enum ChatEndpoint {
  CHATS = '/v1/chats',
  CHAT = '/v1/chats/{id}',
  CHAT_FIRESTORE = '/v1/chats/{id}/firestore',
  CHAT_READ = '/v1/chats/{id}/read',
  MESSAGES = '/v1/chats/{id}/messages',
  MESSAGE = '/v1/chats/{chatId}/messages/{messageId}',
  GAMBIT_CHAT_MESSAGES = '/v1/chats/{id}/gambit_messages',
}

export enum UserEndpoint {
  USERS = '/v1/users',
  GET_USER_LOCATION_FROM_COUNTRY = '/v1/users/locate_country',
  GET_USER_INFO = '/v1/users/info',
  GET_USER_NOTIFICATION_PREFS = '/v1/users/notification_prefs',
  GET_USER_UNIT_TYPE = '/v1/users/unit',
  UPDATE_USER_ACCENT_HUE = '/v1/users/accent-hue',
  MARK_ACTIVE = '/v1/users/active',
  UPDATE_RECENT_CLOCK_CONTROLS = '/v1/users/clock-controls',
  GET_USER_CLUBS = '/v1/users/clubs',
  RECENT_INVITEES = '/v1/users/recent-invitees',
  GET_USER_DETAILS = '/v1/users/{id}/details',
  GET_USER_DETAILS_BY_NAME = '/v1/users/name/{username}',
  VALIDATE_USERNAME = '/v1/users/username/valid',
  CHECK_USERNAME = '/v1/users/username/check/{username}',
  UPDATE_PROFILE = '/v1/users/profile',
  UPDATE_IMAGES = '/v1/users/images',
  UPDATE_LOCATION = '/v1/users/location',
  UPDATE_CITY = '/v1/users/city',
  FOLLOW_USER = '/v1/users/follow/{id}',
  UNFOLLOW_USER = '/v1/users/unfollow/{id}',
  BLOCK_USER = '/v1/users/block/{id}',
  UNBLOCK_USER = '/v1/users/unblock/{id}',
  HANDSHAKE_CODE = '/v1/users/handshake-code',
  HANDSHAKE_CODE_RESOLVE = '/v1/users/handshake-code/{code}',
  HANDSHAKES = '/v1/users/handshake',
  HANDSHAKE_PASSERBY = '/v1/users/handshake/passerby',
  HANDSHAKE_PASSERBY_CLAIM = '/v1/users/handshake/passerby/claim',
  HANDSHAKE = '/v1/users/handshake/{id}',
  HANDSHAKES_LIVE = '/v1/users/handshakes/live',
  HANDSHAKE_CLOSE = '/v1/users/handshake/{id}/close',
  HANDSHAKE_IMAGE = '/v1/users/handshake/{id}/image/{imageId}',
  HANDSHAKE_ADD_IMAGE = '/v1/users/handshake/{id}/image',
  HANDSHAKE_NOTE = '/v1/users/handshake/{id}/note',
  HANDSHAKE_STAND_IN = '/v1/users/handshake/{id}/stand-in',
  HANDSHAKE_SUGGESTION = '/v1/users/handshake/{id}/suggestion',
  HANDSHAKE_DEAL = '/v1/users/handshake/deal',
  HANDSHAKE_POSITIONS = '/v1/users/handshake/{id}/positions',
  HANDSHAKE_POSITION = '/v1/users/handshake/{id}/position',
  HANDSHAKE_STARTED_POSITION = '/v1/users/handshake/{id}/started-position',
  HANDSHAKE_DECLINED_POSITION = '/v1/users/handshake/{id}/declined-position',
  HANDSHAKE_POSITION_INDEX = '/v1/users/handshake/{id}/position/{positionIndex}',
}

export enum NotificationEndpoint {
  GET_NOTIFICATIONS = '/v1/notifications',
  READ_NOTIFICATION = '/v1/notifications/read/{id}',
  READ_NOTIFICATIONS = '/v1/notifications/read',
  NOTIFICATION_TOKEN = '/v1/notifications/notificationToken',
  /** Path param must match `urlParams.token` (FCM token, URI-encoded). */
  NOTIFICATION_TOKEN_BY_TOKEN = '/v1/notifications/notificationToken/{token}',
  NOTIFICATION_TOKEN_DEACTIVATE_ALL = '/v1/notifications/notificationToken/deactivate',
}

export enum ReportEndpoint {
  LOCATION = '/v1/locations/{id}/report',
  LOCATION_COMMENT = '/v1/locations/comments/{id}/report',
  BLOB = '/v1/blobs/{id}/report',
  USER = '/v1/users/report/{id}',
  GAMBIT = '/v1/gambits/{id}/report',
  CLUB = '/v1/clubs/{id}/report',
}

export enum AdminEndpoint {
  LOCATION = '/v1/locations/{id}',
  LOCATIONS = '/v1/locations',
  STATS = '/v1/admin/stats',
  USER = '/v1/users/{id}',
  USER_ADMIN_FLAGS = '/v1/users/{id}/admin_flags',
  USERS = '/v1/admin/users',
  USERNAME_ISSUES = '/v1/admin/users/username-issues',
  REPORT_LOCATIONS = '/v1/admin/locations/reports',
  REPORT_LOCATION_COMMENTS = '/v1/admin/locations/comments/reports',
  REPORT_BLOBS = '/v1/admin/blobs/reports',
  REPORT_USERS = '/v1/admin/users/reports',
  REPORT_GAMBITS = '/v1/admin/gambits/reports',
  REPORT_CLUBS = '/v1/admin/clubs/reports',
  SPARKS = '/v1/gambits/admin_sparks',
  SPARK = '/v1/gambits/admin_sparks/{id}',
  SPARK_MOVE = '/v1/gambits/admin_move_sparker/{id}',
}

export enum ChessboardEndpoint {
  GET_BOARD = '/v1/chessboards/{id}',
  GET_MY_BOARDS = '/v1/chessboards/me',
  GET_WORLD_BOARDS = '/v1/chessboards/world',
  GET_ALL_BOARDS = '/v1/chessboards/admin/all',
  GET_VETTED_LOCATIONS = '/v1/chessboards/vetted-locations',
  GET_ACTIVE_BY_LOCATION = '/v1/chessboards/location/{locationId}/active',
  GET_COMPLETED_BY_LOCATION = '/v1/chessboards/location/{locationId}/completed',
  GET_MOVES = '/v1/chessboards/{id}/moves',
  GET_ACTION_LOGS = '/v1/chessboards/{id}/actions',
  CREATE = '/v1/chessboards',
  MAKE_MOVE = '/v1/chessboards/{id}/move',
  PERFORM_ACTION = '/v1/chessboards/{id}/action',
  FIRESTORE = '/v1/chessboards/{id}/firestore',
  ABANDON = '/v1/chessboards/admin/{id}/abandon',
  DELETE_BOARD = '/v1/chessboards/admin/{id}',
}

export enum DuelEndpoint {
  CREATE = '/v1/duels',
  JOIN = '/v1/duels/join',
  ACTIVE = '/v1/duels/active',
  MINE = '/v1/duels/mine',
  GET_BY_CODE = '/v1/duels/code/{code}',
  GET_DUEL = '/v1/duels/{id}',
  GET_MOVES = '/v1/duels/{id}/moves',
  READY = '/v1/duels/{id}/ready',
  START = '/v1/duels/{id}/start',
  MAKE_MOVE = '/v1/duels/{id}/move',
  PING = '/v1/duels/{id}/ping',
  CANCEL = '/v1/duels/{id}/cancel',
  RESIGN = '/v1/duels/{id}/resign',
  OFFER_DRAW = '/v1/duels/{id}/draw',
  ACCEPT_DRAW = '/v1/duels/{id}/draw/accept',
  DECLINE_DRAW = '/v1/duels/{id}/draw/decline',
  REMOVE_ME = '/v1/duels/{id}/me',
}

export enum SeedEndpoint {
  GET_STATS = '/v1/seeds/stats',
}

export enum MapPuzzleEndpoint {
  TRACES = '/v1/traces',
  TRACE_OPEN = '/v1/traces/{traceId}/open',
  TRACE_SOLVE = '/v1/traces/{traceId}/solve',
  TRACE_VIEW = '/v1/traces/{traceId}/view',
  TRACE_PREVIEW = '/v1/traces/{traceId}/preview',
}

export enum WalkEndpoint {
  CREATE = '/v1/walk',
  ACTIVE = '/v1/walk/active',
  DAILY_CARDS = '/v1/walk/daily-cards',
  HISTORY = '/v1/walk/history',
  START_THINK = '/v1/walk/{sessionId}/start-think',
  PUZZLE_TIMEOUT = '/v1/walk/{sessionId}/puzzle-timeout',
  SUBMIT_MOVE = '/v1/walk/{sessionId}/submit-move',
  SYNC = '/v1/walk/{sessionId}/sync',
  REVEAL = '/v1/walk/{sessionId}/reveal',
  WALK_REDS = '/v1/walk/{sessionId}/walk-reds',
  FINISH = '/v1/walk/{sessionId}/finish',
  UPDATE_SPOTS = '/v1/walk/{sessionId}/spots',
  SUMMARY = '/v1/walk/{sessionId}/summary',
  STREAK_RECORDS = '/v1/walk/streak-records',
  FIELD_STATS = '/v1/walk/field-stats',
  TRACE_TOTALS = '/v1/walk/trace-totals',
  DELETE = '/v1/walk/{sessionId}',
}

export enum BugReportEndpoint {
  CREATE = '/v1/bug-reports',
}

export enum CloudflareEndpoint {
  LOCATE = '/cflocate',
}
